import classNames from 'classnames';

import { formatNewsUpdatedLabel } from '@lib/player-news';

type PlayerNewsNoteProps = {
  /** FPL's availability note, e.g. "Knee injury - Expected back 15 Sep". */
  news?: string | null;
  /** When FPL last changed the note. */
  newsAddedAt?: string | null;
  className?: string;
};

/**
 * FPL's own injury or suspension note, shown verbatim beneath a player's
 * availability pill. Renders nothing when there is no note, so a fit player
 * gets no empty line.
 */
export const PlayerNewsNote = ({
  news,
  newsAddedAt,
  className
}: PlayerNewsNoteProps) => {
  if (!news) return null;

  const updatedLabel = formatNewsUpdatedLabel(newsAddedAt);

  return (
    <p
      className={classNames(
        'text-[13px] md:text-sm leading-snug text-neutral-700',
        className
      )}
      data-cy="player-news"
    >
      <span>{news}</span>
      {updatedLabel && (
        <span className="ml-1.5 text-xs text-neutral-500 whitespace-nowrap">
          {updatedLabel}
        </span>
      )}
    </p>
  );
};

export default PlayerNewsNote;
